module.exports = __webpack_public_path__ + "static/media/ECI88_BtnLivechat.d8da4de4.png";